import React from "react";
import { useIntl } from "gatsby-plugin-react-intl";

import ExternalLinks from "../../utils/externalLinks";
import stargazerHero from "../../img/stargazer-wallet/stargazer-hero.jpg";

import Button from "../Button";
import ExternalLink from "../ExternalLink";

import { TextContainer, ButtonsContainer, ImageContainer } from "./styles";
import { useIsMobile } from "../../utils/isMobile";

function StargazerImageText({ title, content, image }) {
  const intl = useIntl();

  const isMobile = useIsMobile();

  return (
    <>
      <TextContainer>
        <h1>
          {title ?? intl.formatMessage({ id: "stargazer_wallet_page_title" })}
        </h1>
        <p>
          {content ??
            intl.formatMessage({
              id: "stargazer_wallet_page_description",
            })}
        </p>
        <ButtonsContainer>
          <Button
            backgroundColor="rgba(255, 255, 255, 0.1);"
            hoverColor="#1552EF"
          >
            <ExternalLink href={ExternalLinks.STARGAZER_WALLET_IOS}>
              IOS
            </ExternalLink>
          </Button>
          <Button
            backgroundColor="rgba(255, 255, 255, 0.1);"
            hoverColor="#1552EF"
          >
            <ExternalLink href={ExternalLinks.STARGAZER_WALLET_ANDROID}>
              Android
            </ExternalLink>
          </Button>
          <Button
            backgroundColor="rgba(255, 255, 255, 0.1);"
            hoverColor="#1552EF"
          >
            <ExternalLink href={ExternalLinks.STARGAZER_WALLET_CHROME}>
              Chrome
            </ExternalLink>
          </Button>
        </ButtonsContainer>
      </TextContainer>
      {!isMobile &&
        (image ?? (
          <ImageContainer>
            <img src={stargazerHero} alt="iphone" />
          </ImageContainer>
        ))}
    </>
  );
}

export default StargazerImageText;
